// src/components/molecules/SubmissionActions.js

import React from "react";
import { Box, Button } from "@mui/material";
import { useTheme } from "styled-components";
import PropTypes from "prop-types";

const SubmissionActions = ({
  onSaveDraft,
  onSubmit,
  saveDraftText,
  videoUploaded,
  paySubmissionFee,
  isPublishing,
  disabled,
}) => {
  const theme = useTheme();

  const handleSaveClick = () => {
    onSaveDraft(); // Ensure no parameters are passed
  };

  const handleSubmitClick = (event) => {
    event.preventDefault(); // Prevent any default action
    onSubmit(); // Call the provided onSubmit function
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        gap: 2,
        mt: 4,
        mb: 4,
      }}
    >
      <Button
        type="button" // Explicitly set the type to "button"
        variant="contained"
        onClick={handleSaveClick} // Use the new handler
        // disabled={disabled || isPublishing} // Disabled when 'disabled' or 'isPublishing' is true
        sx={{
          backgroundColor: theme.colors.blue,
          color: "white",
          fontFamily: "basic-sans",
          fontWeight: "bold",
          borderRadius: "50px",
          textTransform: "none",
          padding: "10px 30px",
          "&:hover": { backgroundColor: theme.colors.green },
          "&.Mui-disabled": {
            backgroundColor: theme.colors.darkGray,
            color: theme.colors.lightGray,
          },
        }}
      >
        {saveDraftText}
      </Button>

      <Button
        type="button" // Explicitly set the type to "button"
        variant="contained"
        onClick={handleSubmitClick} // Use the new function
        disabled={
          !videoUploaded || paySubmissionFee || disabled || isPublishing
        } // Disabled based on various conditions
        sx={{
          backgroundColor: theme.colors.green,
          color: "white",
          fontFamily: "basic-sans",
          fontWeight: "bold",
          borderRadius: "50px",
          textTransform: "none",
          padding: "10px 30px",
          "&:hover": {
            backgroundColor: theme.colors.blue,
          },
          "&.Mui-disabled": {
            backgroundColor: theme.colors.darkGray,
            color: theme.colors.lightGray,
          },
        }}
      >
        Post your Submission
      </Button>
    </Box>
  );
};

SubmissionActions.propTypes = {
  onSaveDraft: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  saveDraftText: PropTypes.string.isRequired,
  videoUploaded: PropTypes.bool.isRequired,
  paySubmissionFee: PropTypes.bool.isRequired,
  isPublishing: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default SubmissionActions;
